import {
  type FieldOverrides,
  type Form,
  type FormField,
  type MultilineAddressValidation,
} from '@wix/ambassador-forms-v4-form/types';

export function applyValidationProperties(
  multilineAddressOptions?: MultilineAddressValidation,
) {
  return (addressForms: Form): Form => {
    if (multilineAddressOptions?.fields) {
      const propertiesByTarget = multilineAddressOptions.fields;
      const modifiedFields = addressForms.fields?.map((field) =>
        field.target
          ? overrideFieldValidation(
              field,
              propertiesByTarget[
                field.target! as keyof typeof propertiesByTarget
              ],
            )
          : field,
      );
      return { ...addressForms, fields: modifiedFields };
    } else {
      return addressForms;
    }
  };
}

function overrideFieldValidation(
  field: FormField,
  fieldOverrides?: FieldOverrides,
): FormField {
  if (fieldOverrides && field.validation) {
    return {
      ...field,
      validation: {
        ...field.validation,
        required: fieldOverrides.required ?? field.validation.required,
      },
    };
  } else {
    return field;
  }
}
